import { render, staticRenderFns } from "./EditWeights.vue?vue&type=template&id=6076750f&"
import script from "./EditWeights.vue?vue&type=script&lang=js&"
export * from "./EditWeights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports